import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import PageLayout from '@/components/layout/PageLayout';

const PrivacyPage = () => {
  return (
    <PageLayout>
      <section className="pb-24 pt-8" data-testid="privacy-page">
        <div className="max-w-3xl mx-auto px-6">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <h1 className="font-heading text-4xl sm:text-5xl font-bold text-taxera-charcoal mb-4">
              Privacy Policy
            </h1>
            <p className="text-slate-500 mb-12">Last updated: February 2026</p>

            <div className="prose prose-slate max-w-none space-y-8">
              <section>
                <h2 className="font-heading text-2xl font-bold text-taxera-charcoal">1. Controller</h2>
                <p className="text-slate-600 leading-relaxed">
                  Taxera Technologies GmbH, Sihleggstrasse 23, 8832 Wollerau, Switzerland ("Taxera", "we", "us") is the data controller for the processing of personal data collected through this website (taxera.tech).
                </p>
                <p className="text-slate-600 leading-relaxed">
                  Contact for data protection inquiries: <a href="mailto:privacy@taxera.tech" className="text-taxera-blue hover:underline">privacy@taxera.tech</a>
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-bold text-taxera-charcoal">2. Data We Collect</h2>
                <p className="text-slate-600 leading-relaxed">We collect and process the following personal data:</p>
                <ul className="list-disc pl-6 text-slate-600 space-y-2">
                  <li><strong>Account data:</strong> Name, email address, company, country, and role when you register for an account.</li>
                  <li><strong>Contact data:</strong> Name, email, phone, company, and message content when you contact us or request a demo.</li>
                  <li><strong>Usage data:</strong> Pages visited, features used, browser type, IP address, and device information.</li>
                  <li><strong>Calculator data:</strong> Inputs provided to our compliance calculators (anonymized and aggregated).</li>
                  <li><strong>Newsletter data:</strong> Email address and subscription preferences.</li>
                </ul>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-bold text-taxera-charcoal">3. Legal Basis</h2>
                <p className="text-slate-600 leading-relaxed">We process your personal data based on:</p>
                <ul className="list-disc pl-6 text-slate-600 space-y-2">
                  <li><strong>Consent (Art. 6(1)(a) GDPR):</strong> Newsletter subscriptions, cookies, and marketing communications.</li>
                  <li><strong>Contractual necessity (Art. 6(1)(b) GDPR):</strong> Account creation and service delivery.</li>
                  <li><strong>Legitimate interest (Art. 6(1)(f) GDPR):</strong> Website analytics, security, and product improvement.</li>
                </ul>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-bold text-taxera-charcoal">4. Data Retention</h2>
                <p className="text-slate-600 leading-relaxed">
                  We retain personal data only as long as necessary for the purposes for which it was collected. Account data is retained for the duration of the account relationship plus 12 months. Contact form submissions are retained for 24 months. Usage data is anonymized after 26 months.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-bold text-taxera-charcoal">5. Your Rights</h2>
                <p className="text-slate-600 leading-relaxed">Under GDPR, you have the right to:</p>
                <ul className="list-disc pl-6 text-slate-600 space-y-2">
                  <li>Access your personal data</li>
                  <li>Rectify inaccurate data</li>
                  <li>Request erasure ("right to be forgotten")</li>
                  <li>Restrict processing</li>
                  <li>Data portability</li>
                  <li>Object to processing</li>
                  <li>Withdraw consent at any time</li>
                </ul>
                <p className="text-slate-600 leading-relaxed">
                  To exercise these rights, contact us at <a href="mailto:privacy@taxera.tech" className="text-taxera-blue hover:underline">privacy@taxera.tech</a>.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-bold text-taxera-charcoal">6. International Transfers</h2>
                <p className="text-slate-600 leading-relaxed">
                  Your data is primarily stored in Switzerland and the European Economic Area. Switzerland has an adequacy decision from the European Commission. For any transfers outside the EEA, we rely on Standard Contractual Clauses (SCCs).
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-bold text-taxera-charcoal">7. Security</h2>
                <p className="text-slate-600 leading-relaxed">
                  We implement appropriate technical and organizational measures to protect your data, including encryption in transit and at rest, access controls, and regular security audits. Taxera is ISO 27001 certified.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-bold text-taxera-charcoal">8. Contact</h2>
                <p className="text-slate-600 leading-relaxed">
                  For any privacy-related inquiries or to exercise your rights, please contact:
                </p>
                <p className="text-slate-600">
                  Taxera Technologies GmbH<br />
                  Attn: Data Protection Officer<br />
                  Sihleggstrasse 23, 8832 Wollerau, Switzerland<br />
                  <a href="mailto:privacy@taxera.tech" className="text-taxera-blue hover:underline">privacy@taxera.tech</a>
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </section>
    </PageLayout>
  );
};

export default PrivacyPage;
